"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.multiXTokensToLiquidity = multiXTokensToLiquidity;
exports.multiLiquidityToTokens = multiLiquidityToTokens;
exports.liquidityToTokens = liquidityToTokens;
exports.multiTokensToUsd = multiTokensToUsd;
const maps_js_1 = require("../common/maps.js");
const decimal_js_1 = require("decimal.js");
const coins_js_1 = require("../common/coins.js");
const prices_js_1 = require("./prices.js");
const index_js_1 = require("../index.js");
async function multiXTokensToLiquidity(xTokensHoldings) {
    let holdings = [];
    const exchangeRateMap = await (0, maps_js_1.getPoolExchangeRateMap)();
    holdings = xTokensHoldings.map((holdingsObj) => {
        const conversion = new decimal_js_1.Decimal(exchangeRateMap.get(holdingsObj.poolName));
        const liquidity = new decimal_js_1.Decimal(holdingsObj.holding)
            .mul(conversion)
            .toString();
        return {
            owner: holdingsObj.owner,
            poolName: holdingsObj.poolName,
            holding: liquidity,
        };
    });
    return holdings;
}
async function multiLiquidityToTokens(holdings) {
    let tokenHoldings = [];
    for (const holdingsObj of holdings) {
        const tokens = await liquidityToTokens({
            liquidity: holdingsObj.holding,
            poolName: holdingsObj.poolName,
        });
        if (typeof tokens === "string") {
            tokenHoldings.push({
                user: holdingsObj.owner,
                poolName: holdingsObj.poolName,
                tokens: tokens,
            });
        }
        else {
            tokenHoldings.push({
                user: holdingsObj.owner,
                poolName: holdingsObj.poolName,
                tokenAmountA: tokens[0],
                tokenAmountB: tokens[1],
            });
        }
    }
    tokenHoldings = mergeDuplicateTokenHoldings(tokenHoldings);
    return tokenHoldings;
}
async function liquidityToTokens(params) {
    let holdingUSD;
    if (["NAVI", "ALPHALEND"].includes(maps_js_1.poolInfo[params.poolName].parentProtocolName)) {
        holdingUSD = singleAssetLiquidityToTokens(params.liquidity, params.poolName);
    }
    else if (params.poolName === "ALPHA") {
        holdingUSD = alphaLiquidityToTokens(params.liquidity);
    }
    else if (["CETUS", "BLUEFIN"].includes(maps_js_1.poolInfo[params.poolName].parentProtocolName)) {
        const [holdingA, holdingB] = await doubleAssetliquidityToTokens(params);
        return [holdingA, holdingB];
    }
    else if (maps_js_1.poolInfo[params.poolName].parentProtocolName === "BUCKET") {
        if (params.poolName in maps_js_1.singleAssetPoolCoinMap) {
            holdingUSD = singleAssetLiquidityToTokens(params.liquidity, params.poolName);
        }
    }
    else {
        console.error(params.poolName);
        throw new Error("Unexpected Parent Protocol");
    }
    if (!holdingUSD)
        throw new Error(`holdingsUsd undefined for poolName: ${params.poolName}`);
    return holdingUSD;
}
async function doubleAssetliquidityToTokens(params) {
    const scaled_coin_amounts = await (0, index_js_1.getCoinAmountsFromLiquidity)(params.poolName, params.liquidity, false);
    const coins = (0, maps_js_1.coinsInPool)(params.poolName);
    const coin_amounts = [
        new decimal_js_1.Decimal(scaled_coin_amounts[0])
            .div(new decimal_js_1.Decimal(Math.pow(10, coins_js_1.coinsList[coins.coinA].expo)))
            .toFixed(5),
        new decimal_js_1.Decimal(scaled_coin_amounts[1])
            .div(new decimal_js_1.Decimal(Math.pow(10, coins_js_1.coinsList[coins.coinB].expo)))
            .toFixed(5),
    ];
    return coin_amounts;
}
function alphaLiquidityToTokens(liquidity) {
    const amount = new decimal_js_1.Decimal(liquidity).div(1e9);
    return amount.toFixed(5);
}
function singleAssetLiquidityToTokens(liquidity, pool) {
    const singlePool = pool;
    if (maps_js_1.poolInfo[pool].parentProtocolName === "NAVI" &&
        maps_js_1.poolInfo[pool].strategyType !== "LOOPING") {
        const coin = maps_js_1.singleAssetPoolCoinMap[singlePool].coin;
        let amount = new decimal_js_1.Decimal(liquidity).div(Math.pow(10, 9 - coins_js_1.coinsList[coin].expo));
        amount = amount.div(new decimal_js_1.Decimal(Math.pow(10, coins_js_1.coinsList[coin].expo)));
        return amount.toFixed(5);
    }
    else if ((maps_js_1.poolInfo[pool].parentProtocolName === "NAVI" ||
        maps_js_1.poolInfo[pool].parentProtocolName === "ALPHALEND") &&
        (maps_js_1.poolInfo[pool].strategyType === "LOOPING" ||
            maps_js_1.poolInfo[pool].strategyType === "SINGLE-LOOPING")) {
        const coin = (0, maps_js_1.coinsInPool)(pool);
        const amount = new decimal_js_1.Decimal(liquidity).div(Math.pow(10, coins_js_1.coinsList[coin].expo));
        return amount.toFixed(5);
    }
    else if (maps_js_1.poolInfo[pool].parentProtocolName === "BUCKET" &&
        pool in maps_js_1.singleAssetPoolCoinMap) {
        const coin = maps_js_1.singleAssetPoolCoinMap[singlePool].coin;
        const amount = new decimal_js_1.Decimal(liquidity).div(new decimal_js_1.Decimal(Math.pow(10, coins_js_1.coinsList[coin].expo)));
        return amount.toFixed(5);
    }
    else {
        throw new Error("Incorrect pool in argument");
    }
}
function mergeDuplicateTokenHoldings(tokenHoldings) {
    const uniqueOwnerPoolMap = new Map();
    for (const holding of tokenHoldings) {
        const owner = holding.user;
        const poolName = holding.poolName;
        const key = `${owner}_${poolName}`;
        if (uniqueOwnerPoolMap.has(key)) {
            const existingTokens = uniqueOwnerPoolMap.get(key);
            if ("tokens" in existingTokens) {
                const thisHolding = holding;
                uniqueOwnerPoolMap.set(key, {
                    tokens: (parseFloat(thisHolding.tokens) + parseFloat(existingTokens.tokens))
                        .toFixed(5)
                        .toString(),
                });
            }
            else {
                const thisHolding = holding;
                const tokensObj = {
                    tokenAmountA: (parseFloat(thisHolding.tokenAmountA) +
                        parseFloat(existingTokens.tokenAmountA))
                        .toFixed(5)
                        .toString(),
                    tokenAmountB: (parseFloat(thisHolding.tokenAmountB) +
                        parseFloat(existingTokens.tokenAmountB))
                        .toFixed(5)
                        .toString(),
                };
                uniqueOwnerPoolMap.set(key, tokensObj);
            }
        }
        else {
            if ("tokens" in holding) {
                uniqueOwnerPoolMap.set(key, { tokens: holding.tokens });
            }
            else {
                uniqueOwnerPoolMap.set(key, {
                    tokenAmountA: holding.tokenAmountA,
                    tokenAmountB: holding.tokenAmountB,
                });
            }
        }
    }
    const uniqueOwnerPoolMapArr = Array.from(uniqueOwnerPoolMap);
    const result = uniqueOwnerPoolMapArr.map(([owner_pool, holding]) => {
        const owner = owner_pool.split("_")[0];
        const poolName = owner_pool.split("_")[1];
        return { user: owner, poolName: poolName, ...holding };
    });
    return result;
}
async function multiTokensToUsd(tokensHoldings) {
    const pricePairs = new Set();
    tokensHoldings.map((o) => {
        if ("tokens" in o) {
            const thisCoins = (0, maps_js_1.coinsInPool)(o.poolName);
            pricePairs.add(`${thisCoins}/USD`);
        }
        else if ("tokenAmountA" in o) {
            const thisCoins = (0, maps_js_1.coinsInPool)(o.poolName);
            pricePairs.add(`${thisCoins.coinA}/USD`);
            pricePairs.add(`${thisCoins.coinB}/USD`);
        }
    });
    const usdHoldings = [];
    const prices = await (0, prices_js_1.getLatestTokenPricePairs)(Array.from(pricePairs), false);
    for (const tokenHolding of tokensHoldings) {
        if ("tokens" in tokenHolding) {
            // SingleAssetTokenHoldings
            const singlePool = tokenHolding.poolName;
            const coin = (0, maps_js_1.coinsInPool)(singlePool);
            const priceOfCoin = prices[`${coin}/USD`];
            if (priceOfCoin) {
                const amountInUSD = new decimal_js_1.Decimal(tokenHolding.tokens).mul(priceOfCoin);
                usdHoldings.push({
                    owner: tokenHolding.user,
                    poolName: tokenHolding.poolName,
                    holding: amountInUSD.toFixed(2).toString(),
                });
            }
        }
        else {
            // DoubleAssetTokenHoldings
            const poolName = tokenHolding.poolName;
            const coin1 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin1;
            const coin2 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin2;
            const priceOfCoin1 = prices[`${coin1}/USD`];
            const priceOfCoin2 = prices[`${coin2}/USD`];
            if (priceOfCoin1 && priceOfCoin2) {
                const amount = new decimal_js_1.Decimal(tokenHolding.tokenAmountA)
                    .mul(priceOfCoin1)
                    .add(new decimal_js_1.Decimal(tokenHolding.tokenAmountB).mul(priceOfCoin2));
                usdHoldings.push({
                    owner: tokenHolding.user,
                    poolName: tokenHolding.poolName,
                    holding: amount.toFixed(2).toString(),
                });
            }
        }
    }
    return usdHoldings;
}
//# sourceMappingURL=userHoldings.js.map